// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { Container } from 'common/styles/oc-styled-components';
import { DIMENSIONS } from 'providers/WindowDimensionsProvider';
import { clinicIsPremium } from 'utils/helpers';

import { combineAllReviews } from '../../../common/helpers/common-helpers';
import BookingWidget from '../BookingWidget/BookingWidget';
import Guarantee from '../Guarantee/Guarantee';
import ProfileHeaderDesktop from '../ProfileHeaderDesktop/ProfileHeaderDesktop';
import ProfileHeaderMobile from '../ProfileHeaderMobile/ProfileHeaderMobile';
import ProfileHeaderTablet from '../ProfileHeaderTablet/ProfileHeaderTablet';

// Other

// Component
const ProfileHeaderWithBookingWidget = ({
  hasInsurance,
  images,
  inNetwork,
  layout,
  mostHelpfulReview,
  refToBookingWidget,
  refToReviews,
  clinic,
}) => {
  const reviews = combineAllReviews(clinic);

  if (layout === DIMENSIONS.TABLET) {
    return (
      <Container flexDirection="column" padding="30px 0 0">
        <ProfileHeaderTablet
          clinicId={clinic.id}
          hasInsurance={hasInsurance}
          images={images}
          inNetwork={inNetwork}
          isSuperPractice={clinic.isSuperPractice || clinicIsPremium(clinic)}
          name={clinic.name}
          address={clinic.address}
          refToReviews={refToReviews}
          reviewsCount={reviews.length}
          reviews={reviews}
          isProspectLead={(clinic.metadata || {}).prospectLead || false}
          aggregateSubRatings={clinic.aggregateSubratings}
        />
        <div ref={refToBookingWidget} tabIndex="-1">
          <BookingWidget />
        </div>
        <Guarantee />
      </Container>
    );
  }
  if (layout === DIMENSIONS.MOBILE) {
    return (
      <Container padding="5px" flexDirection="column">
        <ProfileHeaderMobile
          clinicId={clinic.id}
          hasInsurance={hasInsurance}
          images={images}
          inNetwork={inNetwork}
          isSuperPractice={clinic.isSuperPractice || clinicIsPremium(clinic)}
          name={clinic.name}
          address={clinic.address}
          refToReviews={refToReviews}
          reviewsCount={reviews.length}
          reviews={reviews}
          isProspectLead={(clinic.metadata || {}).prospectLead || false}
          aggregateSubRatings={clinic.aggregateSubratings}
        />
        <div ref={refToBookingWidget} tabIndex="-1">
          <BookingWidget />
        </div>
        <Guarantee />
      </Container>
    );
  }
  return (
    <>
      <ProfileHeaderDesktop
        clinicId={clinic.id}
        hasInsurance={hasInsurance}
        images={images}
        inNetwork={inNetwork}
        isSuperPractice={clinic.isSuperPractice || clinicIsPremium(clinic)}
        mostHelpfulReview={mostHelpfulReview}
        name={clinic.name}
        address={clinic.address}
        refToReviews={refToReviews}
        reviewsCount={reviews.length}
        reviews={reviews}
        isProspectLead={(clinic.metadata || {}).prospectLead || false}
        aggregateSubRatings={clinic.aggregateSubratings}
      />
    </>
  );
};

ProfileHeaderWithBookingWidget.propTypes = {
  clinic: PropTypes.object,
  hasInsurance: PropTypes.bool,
  images: PropTypes.array,
  inNetwork: PropTypes.bool,
  layout: PropTypes.string,
  mostHelpfulReview: PropTypes.object,
  refToBookingWidget: PropTypes.object,
  refToReviews: PropTypes.object,
};

export default ProfileHeaderWithBookingWidget;
